import list from './list'
import appeal from './appeal'
import appealResult from './appealResult'

export default [list, appeal, appealResult]
